import { KanbanBoard } from '@caldwell619/react-kanban'

export enum TYPES {
  SET_KANBAN = '@@kanban/SET_KANBAN',

  GET_KANBAN_SAGA = '@@kanban/GET_KANBAN_SAGA'
}

export interface KANBAN {
  kanbanData: KanbanBoard<CardKanban>
}

export interface CardKanban {
  id: number
  cpf: string
  title: string
  tag: string
  badge: 'Alta' | 'Média' | 'Baixa'
  phone: string
  email: string
  value: number
  time: string
  borderColor: string
  priorityColor: string
  beneficioColor: string
}
